import styled from "styled-components";
import TrendsTabMenu from "../../Analytics/Insights/TrendsTabMenu";
const Pills = (props) => {
  const { className, onClick, options } = props;

  return (
    <>
      {/* reverting this to normal -> change the title when include insights */}
      {props.title === "Trends" ? (
        <>
          <TrendsTabMenu />
        </>
      ) : (
        <PillWrapperStyle
          id={`${props.idBtn === undefined ? "" : props.idBtn}`}
          className={className}
          onClick={onClick}
        >
          <div className={`wrapper ${props.active ? "active" : ""}`}>
            <p>{props.title}</p>
          </div>
        </PillWrapperStyle>
      )}
    </>
  );
};
export default Pills;

const PillWrapperStyle = styled.button`
  border: none;
  padding: 0;
  margin: 0;
  border-radius: 8px;
  .wrapper {
    cursor: pointer;
    display: inline-block;
    border: solid 1px #dadada;
    border-radius: 8px;
    padding: 7px 16px;
    background-color: #fff;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding: 7px 10px;
      border-radius: 6px;
    }
    &.active {
      background-color: #def6e6;
      border-color: #dadada;
      p {
        color: #09a43a;
      }
    }
    p {
      padding: 0;
      margin: 0;
      color: #7e7e7e;
      font-size: 16px;
      line-height: 1.25;
      font-family: "robotomedium", sans-serif;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 12px;
        line-height: 14px;
      }
    }
  }
`;
